"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FlickrSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FlickrSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Flickr"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "flickr-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M66.5,29h-33A4.5,4.5,0,0,0,29,33.5v33A4.5,4.5,0,0,0,33.5,71h33A4.5,4.5,0,0,0,71,66.5v-33A4.5,4.5,0,0,0,66.5,29ZM42.547,55.906A5.953,5.953,0,1,1,48.5,49.953,5.949,5.949,0,0,1,42.547,55.906Zm14.906,0a5.953,5.953,0,1,1,5.953-5.953A5.949,5.949,0,0,1,57.453,55.906Z"
  })))));
}